<script>
// import simplebar from "simplebar-vue";
import i18n from "../i18n";
import api from "../api";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      showOutsideArraow: false,
      practices: [],
      pcns: [],
      currentStpName: "",
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      current_language: "en",
    };
  },
  components: {
    // simplebar,
    Multiselect,
  },
  methods: {
    handleOpenCalled() {
      this.showOutsideArraow = !this.showOutsideArraow;
      console.log("handleOpenCalled");
    },
    async setCurrentPCN() {
      console.log("setCurrentPCN called", this.selectedPcn);
      // if (!this.selectedPcn) {
      //   console.log("setCurrentPCN inside", this.selectedPcn);
      //   this.selectedPcn = await this.pcns.filter(
      //     (x) => x.practiceData.cms.id == this.$route.params.netId
      //   )[0];
      // }
    },
    async getUserPractices() {
      let url = `/users/${this.currentUser.id}/practices`;
      if (this.currentUser.name == "Super Admin") {
        url = "/api/practices";
      }
      try {
        const { data } = await api.get(url);
        this.practices = data.sort((a, b) => a.name.localeCompare(b.name));
      } catch (e) {
        console.log(e);
      }
    },
    async getPcns() {
      if (!this.practices.length) {
        await this.getUserPractices();
      }
      let pcnIds = this.practices.map((x) => {
        return {
          id: x.pcnId,
        };
      });
      let url = "/api/pcns";
      let filter = {
        where: {
          or: pcnIds,
        },
        include: [
          {
            relation: "practices",
            scope: {
              include: [
                {
                  relation: "practiceData",
                  scope: {
                    include: [
                      {
                        relation: "cms",
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            relation: "practiceData",
            scope: {
              include: [
                {
                  relation: "cms",
                },
              ],
            },
          },
        ],
      };
      filter = encodeURIComponent(JSON.stringify(filter));
      url = `${url}?filter=${filter}`;
      try {
        const { data } = await api.get(url);
        this.pcns = data.sort((a, b) => a.name.localeCompare(b.name));
        // due to dropdown refrsh issue this code is removed
        // if (
        //   !this.selectedPcn ||
        //   this.selectedPcn.practiceData.cms.id != this.$route.params.netId
        // ) {
        //   this.selectedPcn = await this.pcns.filter(
        //     (x) => x.practiceData.cms.id == this.$route.params.netId
        //   )[0];
        // }
      } catch (e) {
        console.log(e);
      }
    },
    async getCurrentStp() {
      let url = "/api/stps";
      let filter = {
        include: [
          {
            relation: "ccgs",
            scope: {
              include: [
                {
                  relation: "pcns",
                  scope: {
                    where: {
                      id: this.currentPcn.id,
                    },
                  },
                },
              ],
            },
          },
        ],
      };
      filter = encodeURIComponent(JSON.stringify(filter));
      url = `${url}?filter=${filter}`;
      try {
        const { data } = await api.get(url);
        const stp = data.find((x) => x.ccgs.length && x.ccgs[0].pcns);
        this.currentStpName = stp.name;
      } catch (e) {
        console.log(e);
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    setLanguage(locale) {
      i18n.locale = locale;
      this.current_language = i18n.locale;
    },
    async init() {
      console.log(
        "this.$route.params.netId",
        this.allPractices.length,
        this.$route.params
      );
      if (this.allPractices.length) {
        this.practices = this.allPractices.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        await this.getPcns();
        await this.getCurrentStp();
        await this.setCurrentPCN();
      } else {
        await this.getPcns();
        await this.getUserPractices();
        await this.getCurrentStp();
        await this.setCurrentPCN();
      }
    },
  },
  computed: {
    currentPage() {
      return this.$route.name === "analyticsresult" ||
        this.$route.name === "Analytics"
        ? "Analytics"
        : "Pages";
    },
    selectedPractice: {
      get() {
        return this.currentPractice &&
          Object.keys(this.currentPractice).length != 0
          ? this.currentPractice
          : null;
      },
      set(newPrac) {
        this.$store.commit("updateCurrentPractice", newPrac);
        api
          .get("/api/practices/" + newPrac.id + "/practice-data")
          .then((response) => {
            this.$store.commit("updateCurrentPracticeData", response.data);
            api
              .get("/api/practice-data/" + response.data.id + "/cms")
              .then((response2) => {
                this.$store.commit("updateCurrentCms", response2.data);
                // this.$router.push({ name: 'Pages', params: {cmsId: response2.data.id} }).catch(()=>{});
                if (newPrac.pcnId) {
                  let url = `/api/pcns/${newPrac.pcnId}`;
                  let filter = {
                    include: [
                      {
                        relation: "practiceData",
                        scope: {
                          include: [
                            {
                              relation: "cms",
                            },
                          ],
                        },
                      },
                    ],
                  };
                  filter = encodeURIComponent(JSON.stringify(filter));
                  url = `${url}?filter=${filter}`;
                  api
                    .get(url)
                    .then((response3) => {
                      this.$store.commit("updateCurrentPcn", response3.data);
                      this.$router
                        .push({
                          name: this.currentPage,
                          params: {
                            netId: response3.data.practiceData.cms.id,
                            cmsId: response2.data.id,
                          },
                        })
                        .catch(() => {});
                      return newPrac;
                    })
                    .catch((e) => {
                      console.log(e);
                    });
                } else {
                  this.$store.commit("updateCurrentPcn", null);
                  return newPrac;
                }
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((e) => {
            console.log(e);
          });
      },
    },
    selectedPcn: {
      get() {
        return this.currentPcn && Object.keys(this.currentPcn).length != 0
          ? this.currentPcn
          : null;
      },
      set(val) {
        this.$store.commit("updateCurrentPractice", val.practices[0]);
        this.$store.commit(
          "updateCurrentPracticeData",
          val.practices[0].practiceData
        );
        this.$store.commit(
          "updateCurrentCms",
          val.practices[0].practiceData.cms
        );
        this.$store.commit("updateCurrentPcn", val);
        this.$router
          .push({
            name: this.$route.name,
            params: {
              netId: val.practiceData.cms.id,
              cmsId: val.practices[0].practiceData.cms.id,
            },
          })
          .catch(() => {});
      },
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<template>
  <header
    id="page-topbar"
    class="ml-auto pl-topbar"
    style="width: calc(100% - 140px)"
  >
    <div class="navbar-header">
      <div class="d-flex">
        <div class="ml-2 d-flex align-items-center justify-content-between">
          <!-- <button v-if="!selectedPractice"
          @click="$router.push({ name: 'Practices' })"
          class="ml-3 btn btn-primary disabled"
          disabled="disabled">
          
          Create Practice
          <strong v-if="!currentUser.isAdmin">(Please contact your Admin)</strong>
          </button> -->

          <template
            v-if="
              $route.path.split('/')[1] == 'network' ||
              $route.path.split('/')[1] == 'home'
            "
          >
            <button
              v-if="showOutsideArraow"
              type="button"
              class="ml-0 pl-3 btn btn-sm font-size-20 header-item text-primary"
              id="vertical-menu-btn"
              style="padding-right: 0px"
            >
              <i class="ri-arrow-down-s-line"></i>
            </button>
            <multiselect
              class="topbar-ms"
              style="width: 75vh"
              track-by="name"
              label="name"
              v-model="selectedPcn"
              :options="pcns"
              :searchable="pcns.length > 5 ? true : false"
              :close-on-select="true"
              :show-labels="false"
              placeholder="Select PCN"
              :allow-empty="false"
              :preselectFirst="true"
              @open="handleOpenCalled"
              @close="handleOpenCalled"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <button
                  v-if="!showOutsideArraow"
                  type="button"
                  class="ml-0 pl-3 btn btn-sm font-size-20 header-item text-primary pR-0"
                  id="vertical-menu-btn"
                >
                  <i class="ri-arrow-down-s-line"></i>
                </button>
                <strong class="nowrap">{{ option.name }}</strong></template
              >
            </multiselect>
          </template>
          <button
            v-else-if="$route.path.split('/')[1] == 'icb'"
            type="button"
            class="ml-0 btn btn-sm font-size-20 header-item text-primary font-weight-medium"
            id="vertical-menu-btn"
          >
            {{ this.currentStpName }}
          </button>
          <template v-else>
            <button
              v-if="showOutsideArraow"
              type="button"
              class="ml-0 pl-3 btn btn-sm font-size-20 header-item text-primary"
              id="vertical-menu-btn"
              style="padding-right: 0px"
            >
              <i class="ri-arrow-down-s-line"></i>
            </button>
            <multiselect
              class="topbar-ms"
              style="width: 75vh"
              track-by="name"
              label="name"
              v-model="selectedPractice"
              :options="practices"
              :searchable="practices.length > 5 ? true : false"
              :close-on-select="true"
              :show-labels="false"
              placeholder="Select Practice"
              :allow-empty="false"
              :preselectFirst="true"
              @open="handleOpenCalled"
              @close="handleOpenCalled"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div style="display: flex">
                  <button
                    v-if="!showOutsideArraow"
                    type="button"
                    class="ml-0 pl-3 btn btn-sm font-size-20 header-item text-primary"
                    id="vertical-menu-btn"
                    style="padding-right: 0px"
                  >
                    <i class="ri-arrow-down-s-line"></i>
                  </button>
                  <div
                    class="nowrap"
                    style="padding-left: 10px; padding-top: 10px"
                  >
                    {{ option.name }}
                  </div>
                </div>
              </template>
            </multiselect>
          </template>

          <!-- <b-dropdown
         v-if="selectedPractice"
          left
          variant="black"
          toggle-class="header-item"
          class="d-inline-block user-dropdown"
          :class="{'show': false}"
          ref="dropdown"
        >
          <template class="mx-0 px-0" v-slot:button-content>
          <button
            type="button"
            class="ml-0 pl-0 btn btn-sm font-size-20 header-item text-primary"
            id="vertical-menu-btn"
          >
            <i class=" ri-arrow-down-s-line"></i>
          </button>
          <span class="font-size-20 text-primary font-weight-medium d-xl-inline-block ml-1" style="letter-spacing: 0.02em;">{{ selectedPractice.name }}</span>

          </template>

          <div style="max-height:60vh; overflow:auto;">
            <div v-for="practice in practices" v-bind:key="practice.id">
              <a v-on:click="selectedPractice = practice; $refs.dropdown.hide(true)" class="bg-white font-size-14 dropdown-item" href="javascript:void(0)"
              :class="{ 'text-primary': selectedPractice.name == practice.name ? true : false}">
                {{ practice.name }}
              </a>
              <div v-if="practices[practices.length - 1].name !== practice.name" class="dropdown-divider"></div>
            </div>
          </div>
        </b-dropdown> -->
        </div>
      </div>
      <div class="d-flex">
        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          variant="black"
          style="
            border-left: 1px solid #dadce3;
            border-right: 1px solid #dadce3;
          "
        >
          <template v-slot:button-content>
            <!-- <i class="ri-notification-3-line text-primary"></i> -->
            <img class="px-2" src="@/assets/images/bell.svg" alt height="25" />

            <!-- <span class="noti-dot"></span> -->
          </template>
          <!-- <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">{{ $t('navbar.dropdown.notification.text')}}</h6>
              </div>
              <div class="col-auto">
                <a href="#!" class="small">{{ $t('navbar.dropdown.notification.subtext')}}</a>
              </div>
            </div>
          </div> -->
          <!-- <simplebar style="max-height: 230px;">
            <a href class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs mr-3">
                  <span class="avatar-title bg-success rounded-circle font-size-16">
                    <i class="ri-checkbox-circle-line"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">Account Activated</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">Text</p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t('navbar.dropdown.notification.item.time')}}
                    </p>
                  </div>
                </div>
              </div>
            </a>

          </simplebar> -->
          <!-- <div class="p-2 border-top">
            <a
              class="btn btn-sm btn-link font-size-14 btn-block text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle mr-1"></i>
              {{ $t('navbar.dropdown.notification.button')}}
            </a>
          </div> -->
        </b-dropdown>

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          class="px-2 d-inline-block user-dropdown"
          style="letter-spacing: 0.02em"
        >
          <template v-slot:button-content>
            <!-- <img src="@/assets/images/logo-sm-dark.png" alt height="22" /> -->

            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/user_icon.svg"
              alt="Header Avatar"
              style="height: 30px"
            />
            <span
              class="font-size-14 text-primary font-weight-medium d-none d-xl-inline-block ml-1"
              style="letter-spacing: 0.02em"
              >{{ currentUser.name }}</span
            >
            <i
              class="font-size-20 text-primary align-middle pl-2 ri-arrow-down-s-line d-none d-xl-inline-block"
            ></i>
            <!-- <i class="font-size-20 text-primary ri-arrow-down-s-line"></i> -->

            <!-- <button
          type="button"
          class="btn btn-sm font-size-20 header-item waves-effect text-primary"
          id="vertical-menu-btn"
        >
          <i class=" ri-arrow-down-s-line"></i>
        </button> -->
          </template>
          <!-- item-->
          <!-- <a class="dropdown-item" href="#">
            <i class="ri-user-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.kevin.list.profile') }}
          </a> -->
          <!-- <div class="dropdown-divider"></div> -->
          <router-link tag="a" to="/logout" class="dropdown-item text-danger"
            >Logout</router-link
          >
          <!-- <a class="dropdown-item text-danger" href="/logout">
            <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
            {{ $t('navbar.dropdown.kevin.list.logout') }}
          </a> -->
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<style>
.topbar-ms > .multiselect__select {
  display: none !important;
}
.topbar-ms > .multiselect__tags > .multiselect__input {
  background-color: #f0f2f5 !important;
  font-size: 17px !important;
  font-weight: 500;
  padding-left: 10px;
}
.topbar-ms > .multiselect__tags > .multiselect__single {
  color: #005eb8 !important;
  background-color: #f0f2f5 !important;
  font-size: 20px !important;
  letter-spacing: 0.02em !important;
  font-weight: 500 !important;
}
.topbar-ms > .multiselect__tags > .multiselect__single > strong {
  font-weight: 500 !important;
}
.topbar-ms > .multiselect__tags {
  background-color: #f0f2f5 !important;
  border: none !important;
  padding: 10px !important;
}
.nowrap {
  white-space: nowrap;
}
.pl-topbar .multiselect__tags {
  width: 500px;
  padding-left: 0px !important;
}
.pl-topbar .multiselect__tags input:placeholder {
  font-size: 20px !important;
}
</style>
